import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SafeResourceUrl} from "@angular/platform-browser";
import { StudyService } from 'src/app/services/domain/study.service';
import {
  AnagraficaUtenteLivelloIstruzioneDto,
  Attestato,
  Conoscenze,
  GetIstruzioneViewModel,
  Lingua
} from 'src/app/models/istruzione.models';
import { SharedEnumModelKeyValue } from 'src/app/models/shared.models';
import { BasePageComponent } from 'src/app/base-page.component';
import { ConfirmationService } from 'primeng/api';
import { JobPostService } from 'src/app/services/domain/jobpost.service';
import { RegistryService } from 'src/app/services/domain/registry.service';
import {AnnunciInEvidenza, IdAnnuncioModel} from 'src/app/models/annunci.models';
import { ActivatedRoute } from '@angular/router';
import { AnagraficaDto, AnagraficaUtenteCandidature, CandidatureGetListViewModel } from 'src/app/models/anagrafica.models';
import { Message } from 'primeng/api';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css'],
  providers : [RegistryService, ConfirmationService, JobPostService, StudyService]
})
export class DetailsComponent extends BasePageComponent  implements OnInit {
  constructor(private registryService : RegistryService,
              private confirmationService : ConfirmationService,
              private jobPostService : JobPostService,
              private studyService : StudyService,
              private route : ActivatedRoute) {
    super();

  }

  public jobPostSelected : AnnunciInEvidenza = new AnnunciInEvidenza();
  public headerDetailsDialog : string = "";
  public candidatureFilterModel : CandidatureGetListViewModel = new CandidatureGetListViewModel();
  public lstCandidature : AnagraficaUtenteCandidature[] = [];
  public lstJobPostEvidence : AnnunciInEvidenza[] = [];
  public registryDto : AnagraficaDto = new AnagraficaDto();

  public showDetailsDialog : boolean = false;
  public lstTitoloStudio : AnagraficaUtenteLivelloIstruzioneDto[] = [];
  public attestati : Attestato[] = [];
  public languageKnowledges : Lingua[] = [];
  public computerKnowledges : Conoscenze[] = [];
  public code : string | null = null;
  public message: Message[] = [];
  public istruzioneModel: GetIstruzioneViewModel = new GetIstruzioneViewModel();
  public model : IdAnnuncioModel = new IdAnnuncioModel();

  @Input() jobPostId: number = 0;
  @Input() jobPostStr : string = "";
  @Input() showBtnCandidate: boolean = false;
  @Output() close = new EventEmitter<any>();

  ngOnInit(): void {
    this.jobPostSelected.IdCommessaAnnuncio = this.jobPostId;
    this.jobPostSelected.IdCommessaAnnuncioEnc = this.jobPostStr;
    this.model.IdAnnuncio = this.jobPostSelected.IdCommessaAnnuncio;
    this.model.IdAnnuncioEnc = this.jobPostSelected.IdCommessaAnnuncioEnc;
    this.showDetails(this.model);
  }

  public showDetails(model : IdAnnuncioModel){
    this.headerDetailsDialog = 'Dettaglio annuncio';
    this.showDetailsDialog = true;
    this.asyncCall(() => this.jobPostService.getJobPostBy(model), response =>{
      this.jobPostSelected = response.Item || new AnnunciInEvidenza();
      if(this.jobPostSelected.IsCandidato == true){
        this.showBtnCandidate = false;
        this.message = [
          { severity: 'warn', summary: '', detail: 'Ti sei già candidato a questo annuncio' }
        ];
      }
      else this.showBtnCandidate = true;
      this.getListaStudi();
      this.getListaAttestati();
      this.getListaConoscenzeLingue();
      this.getListaConoscenzeInformatiche();
    });
  }
  public getListaStudi(){
    this.istruzioneModel.Livello = 1;
    this.asyncCall(() => this.studyService.getTypeStudyTitleList(this.istruzioneModel), response =>{
      this.lstTitoloStudio = response.Items || [];

      this.jobPostSelected.studyTypeSelected = "";
      let titoloStudioRichiesto = this.jobPostSelected.IdLivelloIstruzione;
      for(let i = 0; i < this.lstTitoloStudio.length; i++){
        if(titoloStudioRichiesto == this.lstTitoloStudio[i].IdLivelloIstruzione)
          this.jobPostSelected.studyTypeSelected += this.lstTitoloStudio[i].Descrizione;
      }
    })
  }
  public getListaAttestati(){
    this.asyncCall(() => this.studyService.getAttestedTypes(), response =>{
      this.attestati = response.Items || [];
      let lst = this.jobPostSelected.IdAttestatoList.split(",");

      this.jobPostSelected.attestatiSelected = "";
      for(let i = 0; i<lst.length; i++){
        let conoscenza =+lst[i];
        let attestato = this.attestati.filter(x => x.IdAttestato == conoscenza)[0];
        if(attestato != null){
          if(i == lst.length - 1)
            this.jobPostSelected.attestatiSelected += attestato.AttestatoDesc;
          else
            this.jobPostSelected.attestatiSelected += attestato.AttestatoDesc + ', ';
        }
      }
    })
  }
  public getListaConoscenzeLingue(){

    this.asyncCall(() => this.studyService.getLanguage(), response =>{
      this.languageKnowledges = response.Items || [];
      let lst = this.jobPostSelected.IdLinguaList.split(",");

      this.jobPostSelected.languageKnowledgesSelected = "";
      for(let i = 0; i<lst.length; i++){
        let conoscenza =+lst[i];
        let lingua = this.languageKnowledges.filter(x => x.IdLingua == conoscenza)[0];
        if(lingua != null){
          if(i == lst.length - 1)
            this.jobPostSelected.languageKnowledgesSelected += lingua.LinguaDesc;
          else
            this.jobPostSelected.languageKnowledgesSelected += lingua.LinguaDesc+', ';
        }
      }
    })
  }
  public getListaConoscenzeInformatiche(){
    this.asyncCall(() => this.studyService.getKnowledges(), response =>{
      this.computerKnowledges = response.Items || [];
      let lst = this.jobPostSelected.IdConoscenzaList.split(",");

      this.jobPostSelected.computerKnowledgesSelected = "";
      for(let i = 0; i<lst.length; i++){
        let conoscenza =+lst[i];
        let info = this.computerKnowledges.filter(x => x.IdConoscenza == conoscenza)[0];
        if(info != null){
          if(i == lst.length - 1)
            this.jobPostSelected.computerKnowledgesSelected += info.ConoscenzaDesc;
          else
            this.jobPostSelected.computerKnowledgesSelected += info.ConoscenzaDesc+', ';
        }
      }
    })
  }
  public getJobPostProfileCandidate(){
    this.candidatureFilterModel.IdAnagraficaUtente = this.registryDto.IdAnagraficaUtente;
    this.asyncCall(() => this.registryService.candidatureGetList(this.candidatureFilterModel), response => {
      this.lstCandidature = response.Items || [];
    });
  }
  public getJobPostEvidence(){
    this.asyncCall(() => this.jobPostService.getAnnunciInEvidenza(), response => {
      this.lstJobPostEvidence = response.Items || [];
    });
  }
  public insertCandidatura(){
    this.asyncCall(() => this.jobPostService.candidaturaAnnuncio(this.jobPostSelected.IdCommessaAnnuncio), response =>{
      this.showSuccess("Candidatura avvenuta con successo");
      this.getJobPostProfileCandidate();
      this.getJobPostEvidence();
      this.closeDialogDetails();
      this.showDetailsDialog = false;
    })
  }
  public closeDialogDetails(){
    this.close.emit(false);
  }

}

